import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  auth: {
    isLoaded: false,
    isEmpty: true,
    uid: null,
  },
  profile: {
    isLoaded: false,
    isEmpty: true,
  },
  authError: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuth: (state, action) => {
      state.auth = {
        isLoaded: true,
        isEmpty: !action.payload,
        uid: action.payload ? action.payload.uid : null,
        ...action.payload,
      };
    },
    setProfile: (state, action) => {
      state.profile = {
        isLoaded: true,
        isEmpty: !action.payload,
        ...action.payload,
      };
    },
    setAuthError: (state, action) => {
      state.authError = action.payload;
    },
    clearAuth: (state) => {
      state.auth = {
        isLoaded: true,
        isEmpty: true,
        uid: null,
      };
      state.profile = {
        isLoaded: true,
        isEmpty: true,
      };
      state.authError = null;
    },
  },
});

export const { setAuth, setProfile, setAuthError, clearAuth } = authSlice.actions;
export default authSlice.reducer;
